// @flow
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Table, Heading } from '@medeo/components'
import { getAllObservationsFromPatientId } from '@medeo/observations'
import { connect } from 'react-redux'
import moment from 'moment'
import type { Observation } from '@medeo/observations/types/fhir'
import AlertBadge from './AlertBadge'

type StateProps = {
  observations: Array<Observation>
}
type OwnProps = {
  patientId: string
}

type Props = StateProps & OwnProps

const AlertsTable = ({ observations }: Props) => (
  <Table
    headers={[['mesure', 'valeur', 'validation']]}
    rows={observations}
    renderRow={observation => [
      <td key="measure" style={{ display: 'flex', flexDirection: 'column' }}>
        <FormattedMessage id={observation.code.coding[0].code}>
          {label => <Heading>{label}</Heading>}
        </FormattedMessage>
        <span>{moment(observation.effectiveDateTime).calendar()}</span>
      </td>,
      <td key="value" >
        <div style={{ display: 'flex', flexDirection: 'row' }}>
        <AlertBadge color={['LL', 'HH'].includes(observation.interpretation.coding[0].code) ? 'red' : 'orange'}/>
          {' '}
          {observation.valueQuantity.value}
          {observation.valueQuantity.unit}
        </div>
      </td>,
      <td key="validation">
        <button>valider</button>
      </td>
    ]}
  />
)

const mapStateToProps = (state: *, ownProps: OwnProps) => {
  const { patientId } = ownProps
  const allObservations = getAllObservationsFromPatientId(state, patientId)
  const observations = allObservations
    .filter(
      observation =>
        observation &&
        observation.interpretation &&
        observation.interpretation.coding[0].code !== 'N'
    )
    .sort(
      (a, b) => new Date(b.effectiveDateTime) - new Date(a.effectiveDateTime)
    )
  return {
    observations,
    patient: ownProps.patient
  }
}

export default connect(mapStateToProps)(AlertsTable)



// WEBPACK FOOTER //
// ./src/Observations/containers/AlertsTable.js